import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
var QontoConnector = styled(StepConnector)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, _define_property(_obj, "&.".concat(stepConnectorClasses.alternativeLabel), {
        top: 10,
        left: "calc(-50% + 16px)",
        right: "calc(50% + 16px)"
    }), _define_property(_obj, "&.".concat(stepConnectorClasses.active), _define_property({}, "& .".concat(stepConnectorClasses.line), {
        borderColor: "#B00412"
    })), _define_property(_obj, "&.".concat(stepConnectorClasses.completed), _define_property({}, "& .".concat(stepConnectorClasses.line), {
        borderColor: "#B00412"
    })), _define_property(_obj, "& .".concat(stepConnectorClasses.line), _object_spread({
        borderColor: "rgba(176, 4, 18, 0.25)",
        borderTopWidth: 3,
        borderRadius: 1
    }, theme.applyStyles("dark", {
        borderColor: theme.palette.grey[800]
    }))), _obj;
});
var QontoStepIconRoot = styled("div")(function(param) {
    var theme = param.theme;
    return _object_spread_props(_object_spread({
        color: "#eaeaf0",
        display: "flex",
        height: 22,
        alignItems: "center",
        "& .QontoStepIcon-completedIcon": {
            color: "#B00412",
            zIndex: 1,
            fontSize: 22
        },
        "& .QontoStepIcon-circle": {
            color: "rgba(176, 4, 18, 0.25)",
            zIndex: 1,
            fontSize: 22
        }
    }, theme.applyStyles("dark", {
        color: theme.palette.grey[700]
    })), {
        variants: [
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.active;
                },
                style: {
                    color: "#B00412"
                }
            }
        ]
    });
});
function QontoStepIcon(props) {
    var active = props.active, completed = props.completed, className = props.className;
    return /*#__PURE__*/ _jsx(QontoStepIconRoot, {
        ownerState: {
            active: active
        },
        className: className,
        children: completed ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
            className: "QontoStepIcon-completedIcon"
        }) : /*#__PURE__*/ _jsx(TripOriginIcon, {
            className: "QontoStepIcon-circle"
        })
    });
}
QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */ active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */ completed: PropTypes.bool
};
export function StepperLabelWizard(param) {
    var dataLabel = param.dataLabel, activeStep = param.activeStep;
    return /*#__PURE__*/ _jsx(Stack, {
        sx: {
            width: "100%"
        },
        spacing: 4,
        children: /*#__PURE__*/ _jsx(Stepper, {
            alternativeLabel: true,
            activeStep: activeStep > 0 ? activeStep : 0,
            connector: /*#__PURE__*/ _jsx(QontoConnector, {}),
            children: dataLabel.map(function(label) {
                return /*#__PURE__*/ _jsx(Step, {
                    children: /*#__PURE__*/ _jsx(StepLabel, {
                        StepIconComponent: QontoStepIcon,
                        children: label
                    })
                }, label);
            })
        })
    });
}
